export default {
  Name: 'Name ',
  Type: 'Type ',
  KnowledgeBase: 'Knowledge Base ',
  HitCount: 'Hit Count ',
  Context: 'Context ',
  ContextCount: 'Context Count ',
  Input: 'Input ',
  Output: 'Output ',
  SQLStatement: 'SQL Statement ',
  ExecutionStatus: 'Execution Status ',
  BranchSelection: 'Branch Selection ',
  Tokens: 'Tokens ',
  Points: 'Points ',
  Status: 'Status ',
  Success: 'Success',
  Failed: 'Failed',
  Question: 'Question ',
  Answer: 'Answer ',
  NoNodes: 'No options',
}